import React from 'react';
import { translate } from 'react-i18next';
import { Container, Card, Image, Label, Icon, Button } from 'semantic-ui-react';
import {Link} from 'react-router-dom';

import SlidingPopup from 'modules/misc/SlidingPopup.js';
import Utils from 'utils/Utils.js'
import LoadInline from '../loading/LoadInline.js';
import TeamChallengeCard from './TeamChallengeCard.js';
import SelectTeamConfirm from './SelectTeamConfirm.js';
import {colors, fontSizes, fonts, layout, spacings} from 'style';

const style = {
    content: {
        padding: '1px',
        position:'relative',
        padding: spacings.base,
        maxWidth: layout.screenWidth,
        boxShadow: layout.screenShadow,
        marginLeft: 'auto',
        marginRight: 'auto',
        ...fonts.body,
        lineHeight: '1.5',
        backgroundColor: 'white',
        minHeight: '100%',
    },
    loaderContainer: {
        marginLeft:'50%'
    },
    card: {
        overflow:'hidden',
        backgroundColor: colors.themeBlue,
        color: '#fff',
    },
    seasonLabel: {
        border: '1px solid #1E0360',
        backgroundColor: '#fff',
        float: 'right',
    },
    challengeCounts: {
       textAlign: 'center',
        color: colors.themeBlue, 
    },
    challengeCount: {
        fontSize: '0.9em',
    },
    rowLink: {
        padding: '10px 5px 10px 5px',
        display: 'block',
        color: colors.themeDarkerGrey,
    },
    rowLinkHr: {
        opacity: '0.5',
    },
    right: {
        float: 'right',
    },
    arrow: {
        position: 'relative',
        top: '3px',
        paddingLeft: '20px',
    },
    
};

const TeamChallenges = ({t,
                         busy,
                         leaderboards,
                         newCount,
                         completedCount,
                         teamChallengeInfo,
                         selectedLeaderboard,
                         onClickLeaderboard,
                         onClickLeaderboardIcon,
                         onConfirmLeaderboard,
                         onCancelLeaderboard}) => (
    <div style={style.content}>
        {busy && 
            <LoadInline centered vcentered /> 
        }
        {!busy &&
            <div>


                {teamChallengeInfo.invitations>0 &&
                    <div>
                        <Link style={style.rowLink} to={'/team-challenge/invitations'}>
                            {t('Pending Invitations')} 
                            <span style={style.right}>{teamChallengeInfo.invitations}<Icon style={style.arrow} className='icon-arrow-right' /></span>
                        </Link>
                        <hr style={style.rowLinkHr}/>
                    </div>
                }
                {teamChallengeInfo.active>0 &&
                    <div>
                        <Link style={style.rowLink} to={'/team-challenge/active'}>
                            {t('Active Sessions')} 
                            <span style={style.right}>{teamChallengeInfo.active}<Icon style={style.arrow} className='icon-arrow-right' /></span>
                        </Link>
                        <hr style={style.rowLinkHr}/>
                    </div>
                }

                <br />


                {completedCount>0 &&
                    <div style={style.challengeCounts}>
                        {t('Attempted Challenges')}
                        <div style={style.challengeCount}>{t('teamchallenges_num_completed',{num:completedCount})}</div>
                    </div>
                }
                {newCount>0 &&
                    <div style={style.challengeCounts}>
                        {t('New Challenges')}
                        <div style={style.challengeCount}>{t('teamchallenges_num_to_complete',{num:newCount})}</div>
                    </div>
                }

                <br />
                
                <Card.Group>
                {leaderboards.map((leaderboard)=>(
                    <TeamChallengeCard key={leaderboard.id}
                                       centered
                                       leaderboard={leaderboard} 
                                       onClickLeaderboard={onClickLeaderboard}
                                       onClickLeaderboardIcon={onClickLeaderboardIcon} />
                ))}
                </Card.Group>

                <br />

                {teamChallengeInfo.completed>0 &&
                    <div>
                        <Link style={style.rowLink} to={'/team-challenge/history'}>
                            {t('Challenge History')} 
                            <span style={style.right}>{teamChallengeInfo.completed}<Icon style={style.arrow} className='icon-arrow-right' /></span>
                        </Link>
                        <hr style={style.rowLinkHr}/>
                    </div>
                }
            </div>
        }
        {selectedLeaderboard &&
        <SlidingPopup onClose={onCancelLeaderboard}>
            <SelectTeamConfirm leaderboard={selectedLeaderboard} onConfirm={onConfirmLeaderboard} />
        </SlidingPopup>
        }
    </div>
);

export default translate('teamchallenges')(TeamChallenges);



// WEBPACK FOOTER //
// ./src/modules/teamchallenges/TeamChallenges.js